import type { SavedItem } from "./terra-boa-data";
import {
  type BrazilLocation,
  type BrazilMunicipality,
  isValidBrazilLocation,
  loadBrazilMunicipalities,
  locationFromParts,
  normalizeLocationText,
} from "./terra-boa-locations";

function locationIdPart(value: string) {
  return normalizeLocationText(value).replace(/\s+/g, "-");
}

export function savedItemForLocation(location: BrazilLocation): SavedItem | null {
  if (!location.state || !location.municipality) return null;

  if (location.commercialPlaceId && location.commercialPlaceName) {
    return {
      id: `place-${location.commercialPlaceId}`,
      kind: "commercial-place",
      targetId: location.commercialPlaceId,
      name: location.commercialPlaceName,
      subtitle: `${location.municipality}, ${location.state}`,
      state: location.state,
      municipality: location.municipality,
      municipalityCode: location.municipalityCode,
      commercialPlaceId: location.commercialPlaceId,
      commercialPlaceName: location.commercialPlaceName,
      commercialPlaceType: location.commercialPlaceType || "outro",
    };
  }

  return {
    id: `location-${location.state.toLowerCase()}-${location.municipalityCode || locationIdPart(location.municipality)}`,
    kind: "location",
    targetId: location.municipalityCode || `${location.state}-${location.municipality}`,
    name: `${location.municipality}, ${location.state}`,
    subtitle: location.stateName,
    state: location.state,
    municipality: location.municipality,
    municipalityCode: location.municipalityCode,
  };
}

export async function locationFromSavedItem(item: SavedItem, additionalMunicipalities: BrazilMunicipality[] = []): Promise<BrazilLocation | null> {
  if (item.kind !== "location" && item.kind !== "commercial-place") return null;
  await loadBrazilMunicipalities();
  const location = locationFromParts(item, additionalMunicipalities);
  if (!isValidBrazilLocation(location, additionalMunicipalities)) return null;
  if (item.kind === "commercial-place" && (!location.commercialPlaceId || !location.commercialPlaceName)) return null;
  if (item.kind === "location") {
    return { ...location, commercialPlaceId: "", commercialPlaceName: "", commercialPlaceType: "" };
  }
  return location;
}
